import React, {useContext, useEffect, useRef, useState} from "react";
import "./WorkExperience.scss";
import ExperienceCard from "../../components/experienceCard/ExperienceCard";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WorkExperience() {
  const {isDark} = useContext(StyleContext);
  const trackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) {
      return;
    }
    const updateArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      setCanScrollLeft(track.scrollLeft > 8);
      setCanScrollRight(track.scrollLeft < maxScroll - 8);
    };
    updateArrows();
    track.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);
    return () => {
      track.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);

  const scrollByCard = direction => {
    const track = trackRef.current;
    if (!track) {
      return;
    }
    const card = track.firstElementChild;
    const gap = 16; // matches the 1rem gap in WorkExperience.scss
    const step = card ? card.offsetWidth + gap : track.clientWidth;
    track.scrollBy({left: direction * step, behavior: "smooth"});
  };

  if (workExperiences.display) {
    return (
      <div id="experience">
        <Fade bottom duration={1000} distance="20px">
          <div className="experience-container" id="workExperience">
            <div>
              <h1 className="experience-heading">Experiences</h1>
              <div className="experience-carousel">
                <button
                  type="button"
                  aria-label="Previous experiences"
                  className={
                    isDark
                      ? "experience-arrow experience-arrow-left dark-mode-arrow"
                      : "experience-arrow experience-arrow-left"
                  }
                  onClick={() => scrollByCard(-1)}
                  disabled={!canScrollLeft}
                >
                  <i className="fas fa-chevron-left"></i>
                </button>
                <div className="experience-cards-div" ref={trackRef}>
                  {workExperiences.experience.map((card, i) => {
                    return (
                      <ExperienceCard
                        key={i}
                        isDark={isDark}
                        cardInfo={{
                          company: card.company,
                          desc: card.desc,
                          date: card.date,
                          companylogo: card.companylogo,
                          role: card.role,
                          descBullets: card.descBullets
                        }}
                      />
                    );
                  })}
                </div>
                <button
                  type="button"
                  aria-label="Next experiences"
                  className={
                    isDark
                      ? "experience-arrow experience-arrow-right dark-mode-arrow"
                      : "experience-arrow experience-arrow-right"
                  }
                  onClick={() => scrollByCard(1)}
                  disabled={!canScrollRight}
                >
                  <i className="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    );
  }
  return null;
}
